import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import Swal from 'sweetalert2';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-incoming-students',
  templateUrl: './incoming-students.component.html',
  styleUrls: ['./incoming-students.component.css']
})
export class IncomingStudentsComponent implements OnInit {
  incomingStudents;
  errorMessage;
  selectUndefinedOptionValue = undefined;
  academicYearFilter = '0';
  academicYear;
  programmeName = '0';
  programmes;
  terms;
  termName = '0';
  termFilterWiseData;
  studentsWithFilter;

  constructor() { }

  getStudents(): void {
    if (!localStorage.hasOwnProperty('nominations')) {
      localStorage.setItem('nominations', '[]');
    }
    this.incomingStudents = JSON.parse(localStorage.getItem('nominations'));
    this.studentsWithFilter = [];
    this.termFilterWiseData = [];
    this.academicYear = [{academic_year: '2017-2018'}, {academic_year: '2018-2019'}, {academic_year: '2019-2020'}];

    if (this.termName === '0') {
      this.termFilterWiseData = this.incomingStudents;
      this.getFilterWiseData();
    } else {
      for (let i = 0; i < this.incomingStudents.length; i++) {
        const obj = this.incomingStudents[i];
        if (this.termName === obj.term) {
          this.termFilterWiseData.push(obj);
        }
      }
      this.getFilterWiseData();
    }
    if (this.studentsWithFilter.length === 0) {
      this.errorMessage = 'There is no data available for Incoming Students';
    }
  }

  getProgrammes() {
    if (!localStorage.hasOwnProperty('programmes')) {
      localStorage.setItem('programmes', JSON.stringify([{'programme_id': 1, 'name': 'PGP'}, {'programme_id': 2, 'name': 'PGPEM'},
        {'programme_id': 3, 'name': 'EPGP'}]));
      this.programmes = JSON.parse(localStorage.getItem('programmes'));
    } else {
      this.programmes = JSON.parse(localStorage.getItem('programmes'));
    }
  }

  getTerms() {
    if (!localStorage.hasOwnProperty('terms')) {
      localStorage.setItem('terms', JSON.stringify([{'term_id': 1, 'name': 'Term IV'}, {'term_id': 2, 'name': 'Term V'},
        {'term_id': 3, 'name': 'Term VI'}]));
    }
    this.terms = JSON.parse(localStorage.getItem('terms'));
  }

  getFilterWiseData(): void {
    if (this.academicYearFilter === '0' && this.programmeName === '0') {
      this.studentsWithFilter = this.termFilterWiseData;
    } else if (this.academicYearFilter !== '0' && this.programmeName === '0') {
      for (let i = 0; i < this.termFilterWiseData.length; i++) {
        const obj = this.termFilterWiseData[i];
        if (this.academicYearFilter === obj.academic_year) {
          this.studentsWithFilter.push(obj);
        }
      }
    } else if (this.academicYearFilter === '0' && this.programmeName !== '0') {
      for (let i = 0; i < this.termFilterWiseData.length; i++) {
        const obj = this.termFilterWiseData[i];
        if (this.programmeName === obj.programme) {
          this.studentsWithFilter.push(obj);
        }
      }
    } else {
      for (let i = 0; i < this.termFilterWiseData.length; i++) {
        const obj = this.termFilterWiseData[i];
        if (this.academicYearFilter === obj.academic_year && this.programmeName === obj.programme) {
          this.studentsWithFilter.push(obj);
        }
      }
    }
  }


  changeStudentStatus(student): void {
    const that = this;
    Swal({
      title: 'Confirm',
      type: 'question',
      text: 'Do you want to change the status of the student?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#4cb84c',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          /*student.status = that.studentStatus;*/
          localStorage.setItem('nominations', JSON.stringify(that.incomingStudents));
          resolve(true);
        });
      },
      allowOutsideClick: false,
    }).then(function (result) {
      if (result.value === true) {
        that.getStudents();
        Swal({
          title: 'Success',
          type: 'success',
          html: '<p>Student status changed successfully.</p>',
          timer: 1500,
        });
      }
    }, function (cancel) {
      console.log(cancel);
    }).catch(function (error) {
    });
  }

  rejectStudent(student): void {
    const that = this;
    Swal({
      title: 'confirm',
      type: 'question',
      text: 'Do you want to reject the student?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#5cb85c',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: function() {
        return new Promise(function (resolve, reject) {
          student.status = 'Rejected';
          localStorage.setItem('nominations', JSON.stringify(that.incomingStudents));
          resolve(true);
        });
      },
      allowOutsideClick: false
    }).then(function (result) {
      if (result.value === true) {
        that.getStudents();
        Swal({
          title: 'Success',
          type: 'success',
          width: 600,
          padding: 80,
          showCancelButton: false,
          showConfirmButton: true,
          html: '<p>Successfully cleared the student.</p>',
        });
      }
    }, function (cancel) {
      console.log(cancel);
    }).catch(function (error) {
      console.log(error);
    });
  }

  ngOnInit() {
    this.getStudents();
    this.getProgrammes();
    this.getTerms();
  }

}
